// components/ProtectedRoute.js
// import React from 'react';
import { Navigate } from 'react-router-dom';
import useUserRole from '../contexts/useUserRole';
import { ProgressSpinner } from 'primereact/progressspinner';

const ProtectedRoute = ({ allowedRoles, children }) => {
    const { role, loading } = useUserRole();

      if (loading) {
        // return (<p>Loading..</p>);
        return (
          <div style={{
            display: 'flex',
            height: '100vh',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <ProgressSpinner />
          </div>
        );
      }

    if (!allowedRoles.includes(role)) {
        return <Navigate to="/unauthorized" replace />;
    }

    return children;
};

export default ProtectedRoute;
